import { render } from "./B2bProfileParties.vue?vue&type=template&id=546d6ed2&scoped=true&lang=pug"
import script from "./B2bProfileParties.vue?vue&type=script&lang=js"
export * from "./B2bProfileParties.vue?vue&type=script&lang=js"

import "./B2bProfileParties.vue?vue&type=style&index=0&id=546d6ed2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546d6ed2"]])

export default __exports__